export const getUrlWithParams = (path, data) => {
  if (!data) return path;
  return Object.keys(data).reduce(
    (url, key) => url.replace(new RegExp(`:${key}(\\?)?`), data[key]),
    path,
  );
};
